import { render, staticRenderFns } from "./SubmittedProjectDialog.vue?vue&type=template&id=41d94b00&scoped=true&"
import script from "./SubmittedProjectDialog.vue?vue&type=script&lang=js&"
export * from "./SubmittedProjectDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41d94b00",
  null
  
)

export default component.exports